export default __webpack_public_path__ + "static/Mazda-49474b0d9ff69223139cdaa094a2a0cc.jpg";